import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import useCalendarToolGql from './gql/useCalendarToolGql';
import CoolLoading from '../../wedding-wardrobe/src/components/base/CoolLoading';

function CalendarToolQuery(props) {
  const { calendarType, date, setNavigations, children, queryParams } = props;
  const { useCalendarToolQuery } = useCalendarToolGql({ ...queryParams, calendarType });
  const { loading, data, error, refetch } = useCalendarToolQuery(date);

  useEffect(() => {
    if (data && data.calendarTool) {
      // SET PREVIOUS / NEXT WEEK
      const { calendarTool } = data;
      const { previous, next } = calendarTool;
      setNavigations({ previous, next });
    }
  }, [data, loading]);

  if (error) console.log('error', error);
  if (loading) return <CoolLoading />;

  const { calendarTool } = data;

  const { calendar } = calendarTool;

  return (
    <div className="main-calendar-view">
      {children(calendar, refetch)}
    </div>
  );
}

CalendarToolQuery.propTypes = {
  queryParams: PropTypes.object.isRequired,
  calendarType: PropTypes.string.isRequired,
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
  setNavigations: PropTypes.func.isRequired,
};

export default CalendarToolQuery;
